import { JDSToggleProps } from './generated';
import { MODIFIED_PROPS } from '../../generators/modifyProps';

export interface InputToggleProps extends JDSToggleProps {
  id?: string;
  /**
   * @deprecated
   * use stateText prop
   */
  stateConfig?: {
    errorText?: string;
    successText?: string;
    warningText?: string;
    requiredText?: string;
  };

  /**
   * @deprecated
   * use `icon` prop
   */
  prefix?: string | JSX.Element;
  onChange?: (ev: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  name?: string;
  ariaLabel?: string;
  ariaDescribedby?: string;
}

export const PROP_MAP = (
  props: InputToggleProps
): MODIFIED_PROPS<InputToggleProps> => {
  return {
    state: {
      properties: {
        state: props.state
      },
      variations: {
        error: {
          stateText: props.stateConfig?.errorText
        },
        success: {
          stateText: props.stateConfig?.successText
        },
        warning: {
          stateText: props.stateConfig?.warningText
        },
        required: {
          stateText: props.stateConfig?.requiredText
        }
      }
    },
    label: {
      properties: {
        labelText: props.label
      }
    },
    id: {
      properties: {
        id: props.id
      }
    }
  };
};
